import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import withStyles from "utils/withStyles";
import { AddButton, EditButton, DeleteButton } from "../common/Buttons";
import SearchBox from "../common/SearchBox";
import ContentHeader from "../common/ContentHeader";
import TableGenerator from "../../../../../Common/TableGenerator";
import CrudDialog from "../common/CrudDialog";
import { useSnackbar } from "notistack";
import _flatten from "lodash/flatten";
import {
  handleServerErrors,
  handleMultiFilterSearch,
} from "../../utiles/helpers";
import { setProductCategoriesData } from "redux/actions";
import { convertUtcToLocal, dateFormatter } from "utils/helpers";
import styles from "./styles";
import "./styles.css";

const filterLabels = {
  category_name: "category_name",
};

const deviceTypeFields = ["category_name"];

const ReportedCategory = () => {
  const classes = styles();
  const [addModal, setAddModal] = useState(false);
  const [deviceTypeList, setDeviceList] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [page, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(null);
  const [previousPage, setPreviousPage] = useState(null);
  const [firstPage, setFirstPage] = useState(null);
  const [lastPage, setLastPage] = useState(null);
  const [ordering, setOrdering] = useState("category_name");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modulesSelected, setModulesSelected] = useState([]);
  const [filterable, setFilterable] = useState(deviceTypeFields);
  const [query, setQuery] = useState("");
  const [loader, setLoader] = useState(false);
  const current_user = useSelector((state) => state.userReducer.current_user);
  const productCategoriesData = useSelector(
    (state) => state.initialLoadReducer.productCategoriesData
  );
  const [isMutating, setIsMutating] = useState(false);
  const [searchQuery, setSearchQuery] = useState({});
  const [crudLoader, setCrudLoader] = useState(false);
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const fields = [
    {
      key: "id",
      columnName: "ID",
      label: "ID",
      type: "text",
      visible: true,
    },
    {
      key: "category_name",
      columnName: "Reported Category Name",
      label: "Reported Category Name",
      type: "text",
      visible: true,
      render: (value) => value ?? "---",
    },
    {
      key: "weight_limit",
      columnName: "Weight Limit in grams",
      label: "Weight Limit (in grams)",
      type: "text",
      visible: true,
      required: false,
      render: (value) => value ?? "---",
      validations: [
        {
          type: "custom",
          value: (fieldValue) => weightValidation(fieldValue),
          message: "Enter a valid number, with upto 3 decimal places",
        },
      ],
    },
    {
      key: "created_at",
      columnName: "Creation time stamp",
      label: "Creation time stamp",
      type: "text",
      visible: true,
      render: (value) => dateFormatter(convertUtcToLocal(value), true),
    },
    {
      key: "updated_at",
      columnName: "Update time stamp",
      label: "Update time stamp",
      type: "text",
      visible: true,
      render: (value) => dateFormatter(convertUtcToLocal(value), true),
    },
  ];

  const editFields = [
    {
      key: "category_name",
      label: "Reported Category Name",
      type: "text",
      visible: true,
      required: true,
    },
    {
      key: "weight_limit",
      label: "Weight Limit (in grams)",
      type: "text",
      visible: true,
      required: true,
      render: (value) => value ?? "---",
      validations: [
        {
          type: "custom",
          value: (fieldValue) => weightValidation(fieldValue),
          message: "Enter a valid number, with upto 3 decimal places",
        },
      ],
    },
  ];

  const setup = () => {
    setLoader(true);
    setDeviceList([]);
    setModulesSelected([]);
  };

  const handleRes = (data) => {
    setDeviceList(data.results);
    setNextPage(data.next);
    setPreviousPage(data.previous);
    setFirstPage(data.first);
    setLastPage(data.last);
    setLoader(false);
    setDataCount(data.count);
  };

  const weightValidation = (value) => {
    if (!value) return true;
    if (
      !isNaN(parseFloat(value)) &&
      Number(value) >= 0 &&
      (value?.split(".")?.[1] ? value?.split(".")?.[1]?.length <= 3 : true)
    ) {
      return true;
    }
  };

  const getReportedCategory = async (order, max, customPage = page) => {
    const params = {
      ...searchQuery,
      limit: max ? max : rowsPerPage,
      ordering: order ? order : ordering,
      state: "all",
      page: customPage + 1,
    };
    setup();
    const { data } = await window.axiosIns("/reported_category", { params });
    handleRes(data);
  };

  useEffect(() => {
    getReportedCategory();
  }, []);

  const updateProductCategoriesDropdownData = (
    mode,
    payload,
    currentProductCategories
  ) => {
    let updatedProductCategories = [];

    const isArray = Array.isArray(payload);
    const items = isArray ? payload : [payload];

    switch (mode) {
      case "add":
        updatedProductCategories = [
          ...currentProductCategories,
          ...items.filter(
            (item) => !currentProductCategories.some((p) => p.id === item.id)
          ),
        ];
        break;
      case "edit":
        updatedProductCategories = currentProductCategories.map((p) =>
          items.find((i) => i.id === p.id)
            ? {
                ...p,
                ...items.find((i) => i.id === p.id),
              }
            : p
        );
        break;
      case "delete":
        updatedProductCategories = currentProductCategories.filter(
          (p) => !items.includes(p.id)
        );
        break;
      default:
        updatedProductCategories = currentProductCategories;
    }
    return updatedProductCategories;
  };

  const handleAdd = ({ weight_limit, category_name }) => {
    const fd = new FormData();
    fd.append("category_name", category_name ?? "");
    fd.append("weight_limit", weight_limit);
    setIsMutating(true);
    setCrudLoader(true);
    window.axiosIns
      .post(`/reported_category`, fd)
      .then(({ data }) => {
        setCrudLoader(false);
        setAddModal(false);
        enqueueSnackbar("Reported Category added successfully.");
        setTimeout(() => {
          setIsMutating(false);
        }, 200);
        const newList = updateProductCategoriesDropdownData(
          "add",
          data,
          productCategoriesData
        );
        dispatch(setProductCategoriesData(newList));
      })
      .catch((err) => {
        if (err.response.data.detail) {
          enqueueSnackbar(err.response.data.detail);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not add Reported Category. Try again."
          );
        }
        setCrudLoader(false);
        setIsMutating(false);
      })
      .then(() => {
        getReportedCategory();
        setModulesSelected([]);
      });
  };

  const handleEdit = ({ category_name, weight_limit }) => {
    const fd = new FormData();
    fd.append("category_name", category_name ?? "");
    fd.append("weight_limit", weight_limit ?? null);

    const moduleId = modulesSelected[0].id;
    setIsMutating(true);
    setCrudLoader(true);
    window.axiosIns
      .put(`/reported_category/${moduleId}`, fd)
      .then(({ data }) => {
        setCrudLoader(false);
        setEditModal(false);
        enqueueSnackbar("Reported Category edited successfully.");
        setTimeout(() => {
          setIsMutating(false);
        }, 200);

        const newList = updateProductCategoriesDropdownData(
          "edit",
          data,
          productCategoriesData
        );
        dispatch(setProductCategoriesData(newList));
      })
      .catch((err) => {
        if (err.detail) {
          enqueueSnackbar(err.detail);
        } else if (((err.response || {}).data || {}).detail) {
          enqueueSnackbar(((err.response || {}).data || {}).detail);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not edit Reported Category. Try again."
          );
        }
        setCrudLoader(false);
        setEditModal(false);
        setIsMutating(false);
      })
      .then(() => {
        setDeviceList([]);
        setModulesSelected([]);
        getReportedCategory();
      });
  };

  const handleFilter = (arr) => {
    setFilterable(arr);
    if (query !== "") {
      let searchFilter = handleMultiFilterSearch(filterLabels, arr, query);
      setup();
      setPage(0);
      window
        .axiosIns("/reported_category", {
          params: {
            ...searchFilter,
            limit: rowsPerPage,
            ordering,
          },
        })
        .then((data = {}) => {
          handleRes(data.data);
        })
        .catch(() => setLoader(false));
    }
  };

  const changePage = async (url) => {
    setup();
    const { data } = await window.axiosIns(url);
    handleRes(data);
  };

  const handleSearch = (value) => {
    setQuery(value);
    let searchFilter = {};
    if (value !== "") {
      searchFilter = handleMultiFilterSearch(filterLabels, filterable, value);
    }
    setSearchQuery(searchFilter);
    setup();
    setPage(0);
    window
      .axiosIns("/reported_category", {
        params: {
          ...searchFilter,
          limit: rowsPerPage,
          state: "all",
          ordering,
        },
      })
      .then((data = {}) => {
        handleRes(data.data);
      })
      .catch(() => setLoader(false));
  };

  const handleDelete = async () => {
    const idsToDelete = modulesSelected.map((val) => val.id);

    const deletePromises = idsToDelete.map((id) =>
      window.axiosIns
        .delete(`/reported_category/${id}`)
        .then(() => id)
        .catch((err) => {
          if (err.detail) {
            enqueueSnackbar(err.detail);
          } else if (err.response?.data?.detail) {
            enqueueSnackbar(err.response.data.detail);
          } else {
            handleServerErrors(
              err,
              enqueueSnackbar,
              "Could not delete Area. Try again."
            );
          }
          return null;
        })
    );

    const results = await Promise.all(deletePromises);
    const successfulDeletes = results.filter(Boolean);

    if (successfulDeletes.length > 0) {
      const updatedDropdown = updateProductCategoriesDropdownData(
        "delete",
        successfulDeletes,
        productCategoriesData
      );

      dispatch(setProductCategoriesData(updatedDropdown));
    }

    setDeleteModal(false);

    if (deviceTypeList.length - modulesSelected.length === 0 && page > 0) {
      setPage(page - 1);
      changePage(previousPage);
    } else {
      getReportedCategory();
    }

    enqueueSnackbar("Reported Categories deleted successfully.");
  };

  return (
    <div id="sa-modules-wrapper" className={classes.wrapper}>
      <ContentHeader
        description="
        All Reported Categories are listed here. Reported Categories can be used to associate a product to a particular category. This can be used to calculate category wise sales and operative statistics. "
      />
      <div className={classes.toolbar}>
        <div className={classes.crudButtons}>
          <AddButton
            className="mr-3"
            label="Add"
            onClick={() => {
              setAddModal(true);
            }}
            disabled={current_user.type === "SU"}
          />
          <EditButton
            disabled={
              modulesSelected.length !== 1 || current_user.type === "SU"
            }
            className="mr-3"
            label="Edit"
            onClick={() => {
              setEditModal(true);
            }}
          />
          <DeleteButton
            disabled={
              modulesSelected.length === 0 || current_user.type === "SU"
            }
            className="mr-3"
            label="Delete"
            onClick={() => setDeleteModal(true)}
          />
        </div>
        <div className="d-flex">
          <SearchBox
            placeholder="Search"
            multiple={true}
            query={query}
            onChange={handleFilter}
            fields={deviceTypeFields}
            selectedFields={filterable}
            handleSearch={handleSearch}
          />
        </div>
      </div>
      <div className={classes.content}>
        <TableGenerator
          searchQuery={query}
          initialSort={"id"}
          searchColumnsFilter={true}
          fields={_flatten(fields)}
          loader={loader}
          data={deviceTypeList}
          currentPage={page}
          handleSortChange={(ordering) => {
            setOrdering(ordering);
            getReportedCategory(ordering);
          }}
          onPageChange={(page, direction) => {
            setPage(page);
            if (direction === "next") {
              changePage(nextPage);
            } else if (direction === "back") {
              changePage(previousPage);
            } else if (direction === "first") {
              changePage(firstPage);
            } else if (direction === "last") {
              changePage(lastPage);
            }
          }}
          backendPagination={true}
          onRowPerPageChange={(rows) => {
            getReportedCategory(null, rows, 0);
            setRowsPerPage(rows);
            setPage(0);
          }}
          dataCount={dataCount}
          selectedRecords={modulesSelected}
          rowOnePage={10}
          onChangeSelected={(modulesSelected) =>
            setModulesSelected(modulesSelected)
          }
        />
        <CrudDialog
          title="Add Reported Category"
          okText="Add"
          fields={editFields}
          submitButtonDisabled={isMutating}
          description="Please fill in the details below."
          crudLoader={crudLoader}
          onSubmit={(values, hasErrors) => {
            handleAdd(values);
          }}
          open={addModal}
          onClose={() => setAddModal(false)}
        />
        <CrudDialog
          title="Edit Reported Category"
          okText="Save"
          description="Please edit the details below."
          crudLoader={crudLoader}
          fields={editFields.filter((val, i) => i !== 5)}
          submitButtonDisabled={isMutating}
          values={modulesSelected[0]}
          onSubmit={(values) => {
            handleEdit(values);
          }}
          open={editModal}
          onClose={() => setEditModal(false)}
        />
        <CrudDialog
          title="Delete Reported Categories"
          description="Are you sure you want to delete the categories?"
          okText="Delete"
          onSubmit={() => handleDelete()}
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
        />
      </div>
    </div>
  );
};
export default withStyles({}, { withTheme: true })(ReportedCategory);
